import styled from "styled-components";

import FallbackImage from "components/global/FallbackImage";

export const TeamFormFormStack = styled.form.attrs({ className: "space-y-5" })``;

export const TeamFormGridLayout = styled.div.attrs({ className: "grid gap-4" })``;

export const TeamFormContentStack = styled.div.attrs({ className: "space-y-2" })``;

export const TeamFormFieldLabel = styled.label.attrs({
  className: "text-sm text-[var(--brand-muted)]",
})``;

export const TeamFormFieldInput = styled.input.attrs({ className: "brand-input" })``;

export const TeamFormGridLayoutSecondary = styled.div.attrs({
  className: "grid gap-4 md:grid-cols-2",
})``;

export const TeamFormFieldSelect = styled.select.attrs({ className: "brand-input" })``;

export const TeamFormContentStackSecondary = styled.div.attrs({ className: "space-y-3" })``;

export const TeamFormHeaderRow = styled.div.attrs({
  className: "flex flex-col items-start gap-3 sm:flex-row sm:items-center sm:justify-between",
})``;

export const TeamFormMetaText = styled.p.attrs({
  className: "mt-1 text-xs text-[var(--brand-muted)]",
})``;

export const TeamFormFieldLabelSecondary = styled.label.attrs({
  className:
    "brand-button-secondary inline-flex w-full cursor-pointer items-center justify-center gap-2 sm:w-auto",
})``;

export const TeamFormFieldInputSecondary = styled.input.attrs({ className: "hidden" })``;

export const TeamFormContentStackTertiary = styled.div.attrs({
  className: "brand-panel-muted space-y-4",
})``;

export const TeamFormPreviewImage = styled(FallbackImage).attrs({
  className: "mx-auto h-24 w-24 rounded-[20px] sm:mx-0 sm:h-28 sm:w-28 sm:rounded-[22px]",
})``;

export const TeamFormEmptyStatePanel = styled.div.attrs({
  className:
    "mx-auto flex h-24 w-24 items-center justify-center rounded-[20px] border border-dashed border-[var(--brand-border)] bg-[rgba(255,255,255,0.03)] text-center text-sm text-[var(--brand-muted)] sm:mx-0 sm:h-28 sm:w-28 sm:rounded-[22px]",
})``;

export const TeamFormInlineText = styled.span.attrs({
  className: "inline-flex items-center gap-2",
})``;

export const TeamFormActionRow = styled.div.attrs({
  className:
    "flex flex-col-reverse gap-3 border-t border-[var(--brand-border)] pt-5 sm:flex-row sm:justify-end [&>*]:w-full sm:[&>*]:w-auto",
})``;

export const TeamFormSecondaryButton = styled.button.attrs({
  className: "brand-button-secondary w-full sm:w-auto",
})``;

export const TeamFormPrimaryButton = styled.button.attrs({
  className: "brand-button w-full sm:w-auto",
})``;

